import { render, staticRenderFns } from "./Image3.vue?vue&type=template&id=520da14e&"
import script from "./Image3.vue?vue&type=script&lang=js&"
export * from "./Image3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports